export default __webpack_public_path__ + "static/user-3a09b7c2a0738d3eadcd31e535f3cb20.png";